import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Modal } from "../../components/layout/Modal";
import { Button, Loading } from "../../components/widgets";
import RescheduleRertDispatch from "../../components/rert/RescheduleRertDispatch";
import NewDispatchGraph from "../../components/trading/NewDispatchGraph";
import CustomerAppMessageEdit from "../../components/trading/CustomerAppMessageEdit";
import * as rertActions from "../../redux/actions/rert";
import moment from "moment-timezone";
import Permissions, { hasPermission } from "../../permissions";
import RescheduleRertDispatchConfirmation from "../../components/rert/RescheduleRertDispatchConfirmation";

const mapStateToProps = state => ({
  user: state.user,
  constraintsLoading: state.rert.constraintsLoading,
  predictionsLoading: state.rert.predictionsLoading,
  newRertDispatch: state.rert.newRertDispatch,
  rescheduleRertDispatchLoading: state.rert.rescheduleRertDispatchLoading,
  previousRertDispatchMessages: state.rert.previousRertDispatchMessages,
});

const mapDispatchToProps = dispatch => {
  return {
    rertActions: bindActionCreators(rertActions, dispatch),
  };
};

class RescheduleRertDispatchModal extends Component {
  constructor(props) {
    super(props);

    const timezone = this.props.user.account.timezone;
    let startDate = moment(new Date(this.props.dispatch.request.startTime * 1000));

    const momentNow = moment().tz(this.props.user.account.timezone);
    momentNow.minutes(0).seconds(0);

    this.state = {
      dispatchId: this.props.dispatchId,
      powerstationId: this.props.dispatch.powerstation,
      startDateTime: startDate.tz(timezone),
      graphStartDateTime: momentNow,
      duration: this.props.dispatch.request.duration,
      realPowerP: this.props.dispatch.request.realPowerP,
      customerAppMessage: this.props.currentCustomerAppMessage,
      strategy: this.props.dispatch.request.strategy,
    };
  }

  componentDidMount = () => {
    if (this.state.powerstationId) {
      const { powerstationId, startDateTime, duration, realPowerP } = this.state;
      this.fetchDispatchData(powerstationId, startDateTime, duration, realPowerP);
    }
    this.props.rertActions.fetchPreviousRertDispatchMessges();
  };

  componentWillUnmount = () => {
    this.props.rertActions.clearNewRertDispatchGraphData();
    this.props.rertActions.clearPreviousRertDispatchMessages();
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.previousRertDispatchMessages !== nextProps.previousRertDispatchMessages) {
      const message = this.getLastDispatchMessage(nextProps);
      this.setState({
        customerAppMessage: message,
      });
    }
  };

  // Handlers for data changes

  fetchDispatchData = (powerstationId, startDateTime, duration, realPowerP) => {
    const graphStartTime = this.state.graphStartDateTime.unix();
    const dispatchStartTime = this.state.startDateTime.unix();

    this.props.rertActions.fetchNewRertDispatchConstraints(powerstationId, duration, realPowerP);
    this.props.rertActions.fetchNewRertDispatchPrediction(
      powerstationId,
      graphStartTime,
      dispatchStartTime,
      duration,
      realPowerP
    );
  };

  handleStartDateTimeChange = (startDateTime, isBrushChange) => {
    let callback = () => {};
    let graphStartDateTime;
    if (!this.state.startDateTime.isSame(startDateTime, "day") && !isBrushChange) {
      this.props.rertActions.clearNewRertDispatchGraphData();
      const { powerstationId, duration, realPowerP } = this.state;
      callback = () => {
        this.fetchDispatchData(powerstationId, startDateTime, duration, realPowerP);
      };
      graphStartDateTime = this.getGraphStartTime(startDateTime);
    } else {
      callback = this.updateConstaintsAndPredictions;
      graphStartDateTime = this.state.graphStartDateTime;
    }

    if (startDateTime.diff(graphStartDateTime) < 0) {
      startDateTime = graphStartDateTime.clone();
    }

    this.setState(
      {
        startDateTime: startDateTime,
        graphStartDateTime: graphStartDateTime,
      },
      callback
    );
  };

  handleDurationChange = duration => {
    this.setState(
      {
        duration: duration,
      },
      this.updateConstaintsAndPredictions
    );
  };

  handleRealPowerPOnChange = realPowerP => {
    const constraints = this.props.newRertDispatch.constraints;
    const range = constraints.max - constraints.min;
    const snapPercent = 0.04;

    let nextRealPowerP = realPowerP;
    if (range <= 0) {
      nextRealPowerP = realPowerP;
    } else if (realPowerP + range * snapPercent > constraints.max) {
      nextRealPowerP = constraints.max;
    } else if (realPowerP - range * snapPercent < constraints.min) {
      nextRealPowerP = constraints.min;
    } else if (Math.abs(realPowerP) < range * snapPercent) {
      nextRealPowerP = 0;
    }

    this.setState(
      {
        realPowerP: nextRealPowerP,
      },
      this.updateConstaintsAndPredictions
    );
  };

  updateConstraints = () => {
    // This fetches new constraints every time the time selection brush is changed.
    // Unfortunately it is impossible to distinguish between the user actively changing the brush
    // and finishing interacting all together so we just debounce here.
    // Its also better UX this way if the user just pauses whilst dragging we get refreshed constraints.
    if (this.updateConstraintsTimeout) {
      clearTimeout(this.updateConstraintsTimeout);
    }

    this.updateConstraintsTimeout = setTimeout(() => {
      this.props.rertActions.fetchNewRertDispatchConstraints(
        this.state.powerstationId,
        this.state.duration,
        this.state.realPowerP
      );
    }, 300);
  };

  updatePredictions = () => {
    // Debounced as above.
    if (this.updatePredictionsTimeout) {
      clearTimeout(this.updatePredictionsTimeout);
    }

    const graphStartTime = this.state.graphStartDateTime.unix();
    const dispatchStartTime = this.state.startDateTime.unix();
    this.updatePredictionsTimeout = setTimeout(() => {
      this.props.rertActions.fetchNewRertDispatchPrediction(
        this.state.powerstationId,
        graphStartTime,
        dispatchStartTime,
        this.state.duration,
        this.state.realPowerP
      );
    }, 300);
  };

  updateConstaintsAndPredictions = () => {
    this.updateConstraints();
    this.updatePredictions();
  };

  getLastDispatchMessage = props => {
    let latestCreatedAt = 0;
    let latestMessage;
    for (let i in props.previousRertDispatchMessages) {
      const message = props.previousRertDispatchMessages[i];
      if (message.createdAt > latestCreatedAt) {
        latestCreatedAt = message.createdAt;
        latestMessage = message.customerMessage;
      }
    }

    return latestMessage;
  };

  getGraphStartTime = startDateTime => {
    const now = moment().tz(this.props.user.account.timezone);
    if (startDateTime.isSame(now, "day")) {
      return now.minutes(0).seconds(0);
    } else {
      return startDateTime.clone().hours(0).minutes(0).seconds(0);
    }
  };

  executeDispatch = () => {
    // no customer app message for lockouts
    const customerAppMessage = this.state.realPowerP === 0 ? null : this.state.customerAppMessage;

    this.props.rertActions.rescheduleRertDispatch(
      this.state.dispatchId,
      this.state.startDateTime.unix(),
      this.state.duration,
      customerAppMessage
    );

    this.props.returnToDispatchView();
  };

  handleStrategyChange = newStrategy => {
    this.setState({
      strategy: newStrategy,
    });
  };

  handleOnCustomerAppMessageChange = value => {
    this.setState({
      customerAppMessage: value,
    });
  };

  // Permission checks

  strategyAllowed = () => {
    return this.state.realPowerP !== 1;
  };

  // View-state handlers

  showCustomerAppMessageEdit = () => {
    this.setState({
      editCustomerAppMessage: true,
      currentCustomerAppMessage: this.state.customerAppMessage,
    });
  };

  hideCustomerAppMessageEdit = () => {
    this.setState({
      editCustomerAppMessage: false,
    });
  };

  showRescheduleConfirmation = () => {
    this.setState({
      showRescheduleConfirmation: true,
    });
  };

  hideRescheduleConfirmation = () => {
    this.setState({
      showRescheduleConfirmation: false,
    });
  };

  cancelCustomerAppMessageChange = () => {
    this.setState({
      editCustomerAppMessage: false,
      customerAppMessage: this.state.currentCustomerAppMessage,
      currentCustomerAppMessage: null,
    });
  };

  // Rendering

  renderFooter(isLoading) {
    if (this.state.editCustomerAppMessage) {
      return (
        <>
          <Button
            id="back-from-capp-msg-edit-to-dispatch-cancel"
            type="secondary"
            onClick={this.cancelCustomerAppMessageChange}
            icon="chevron-left"
          >
            Cancel
          </Button>
          <Button
            id="back-from-capp-msg-edit-to-dispatch-save"
            type="primary"
            onClick={this.hideCustomerAppMessageEdit}
            icon="check"
          >
            Save Message
          </Button>
        </>
      );
    } else if (this.state.showRescheduleConfirmation) {
      return (
        <>
          <Button
            id="back-to-dispatch-edit-modal"
            type="secondary"
            onClick={this.hideRescheduleConfirmation}
            icon="chevron-left"
          >
            Back
          </Button>
          {(this.props.powerstations || !this.state.allowPowerstationEdit) &&
          this.state.powerstationId ? (
            <>
              <div>
                All times are in <Link to="/user/settings">{this.props.user.account.timezone}</Link>
              </div>
              <Button
                id="add-new-dispatch-modal"
                type="primary"
                onClick={this.executeDispatch}
                icon="bolt"
                loading={isLoading}
              >
                Reschedule
              </Button>
            </>
          ) : null}
        </>
      );
    } else {
      return (
        <>
          <Button
            id="cancel-new-dispatch-modal"
            type="secondary"
            onClick={this.props.returnToDispatchView}
            icon="times"
          >
            Cancel
          </Button>
          {(this.props.powerstations || !this.state.allowPowerstationEdit) &&
          this.state.powerstationId ? (
            <>
              <div>
                All times are in <Link to="/user/settings">{this.props.user.account.timezone}</Link>
              </div>
              <Button
                id="confirm-dispatch-modal"
                type="primary"
                onClick={this.showRescheduleConfirmation}
                icon="chevron-right"
                loading={isLoading}
              >
                Confirm
              </Button>
            </>
          ) : null}
        </>
      );
    }
  }

  render() {
    const newDispatch = this.props.newRertDispatch;

    const isLoading =
      this.props.constraintsLoading ||
      this.props.predictionsLoading ||
      this.props.rescheduleRertDispatchLoading;

    return (
      <Modal>
        <Modal.Header title="Reschedule RERT Dispatch" />
        <Modal.Content>
          <div
            style={{
              opacity: this.state.editCustomerAppMessage ? 1 : 0,
              position: this.state.editCustomerAppMessage ? "relative" : "absolute",
              top: 0,
              left: 0,
              width: "100%",
              transition: "all 0.5s ease-in-out",
              zIndex: this.state.editCustomerAppMessage ? 999999 : -999999,
            }}
          >
            <CustomerAppMessageEdit
              hideCustomerAppMessageEdit={this.hideCustomerAppMessageEdit}
              customerAppMessage={this.state.customerAppMessage}
              onChange={this.handleOnCustomerAppMessageChange}
              previousCustomerAppMessages={this.props.previousRertDispatchMessages}
            />
          </div>
          <div
            style={{
              opacity: this.state.showRescheduleConfirmation ? 1 : 0,
              position: this.state.showRescheduleConfirmation ? "relative" : "absolute",
              top: 0,
              left: 0,
              width: "100%",
              transition: "all 0.5s ease-in-out",
              zIndex: this.state.showRescheduleConfirmation ? 999999 : -999999,
            }}
          >
            <RescheduleRertDispatchConfirmation
              powerstations={this.props.powerstations}
              powerstation={this.state.powerstationId}
              startDateTime={this.state.startDateTime}
              duration={this.state.duration}
              timezone={this.props.user.account.timezone}
              constraints={newDispatch ? newDispatch.constraints : null}
              realPowerP={this.state.realPowerP}
              customerAppMessage={this.state.customerAppMessage}
              strategy={this.state.strategy}
              showMarketData={
                this.props.user.account.suborg_type === "RETAILER" ||
                hasPermission(
                  this.props.user.permissions,
                  Permissions.fleet.dispatches.marketTrader
                )
              }
              returnToDispatchView={this.props.returnToDispatchView}
            />
          </div>
          <div
            style={{
              opacity:
                this.state.editCustomerAppMessage || this.state.showRescheduleConfirmation ? 0 : 1,
              position:
                this.state.editCustomerAppMessage || this.state.showRescheduleConfirmation
                  ? "absolute"
                  : "relative",
              top: 0,
              left: 0,
              width: "100%",
              transition: "all 0.5s ease-in-out",
              zIndex:
                this.state.editCustomerAppMessage || this.state.showRescheduleConfirmation
                  ? -999999
                  : 999999,
            }}
          >
            <div style={{ position: "relative" }}>
              <RescheduleRertDispatch
                powerstation={this.state.powerstationId}
                startDateTime={this.state.startDateTime}
                duration={this.state.duration}
                handleStartDateTimeChange={this.handleStartDateTimeChange}
                handleDurationChange={this.handleDurationChange}
                timezone={this.props.user.account.timezone}
                constraints={newDispatch ? newDispatch.constraints : null}
                onChangeRealPowerP={this.handleRealPowerPOnChange}
                onChangePowerFactor={this.handlePowerFactorOnChange}
                onChangePowerFactorLeadLag={this.handlePowerFactorLeadLagOnChange}
                realPowerP={this.state.realPowerP}
                multipleRegions={
                  newDispatch &&
                  newDispatch.trading &&
                  (this.props.user.account.suborg_type === "RETAILER" ||
                    hasPermission(
                      this.props.user.permissions,
                      Permissions.fleet.dispatches.marketTrader
                    ))
                    ? newDispatch.trading.market.multipleRegions
                    : false
                }
                showMarketData={
                  this.props.user.account.suborg_type === "RETAILER" ||
                  hasPermission(
                    this.props.user.permissions,
                    Permissions.fleet.dispatches.marketTrader
                  )
                }
                showCustomerAppMessageEdit={this.showCustomerAppMessageEdit}
                customerAppMessage={this.state.customerAppMessage}
                previousCustomerAppMessages={this.props.previousRertDispatchMessages}
                strategy={this.state.strategy}
                onStrategyChange={this.handleStrategyChange}
                userPermissions={this.props.user.permissions}
              />

              {this.state.powerstationId ? (
                newDispatch && newDispatch.prediction && newDispatch.adjustedPrediction ? (
                  <div
                    style={{
                      height: "250px",
                      width: "calc(100% - 2px)",
                      marginBottom: "4rem",
                      paddingLeft: "1px",
                    }}
                  >
                    {isLoading ? <Loading horizontal /> : <div style={{ height: "4px" }} />}
                    <NewDispatchGraph
                      dispatchStartTimestamp={this.state.startDateTime.unix()}
                      startTimestamp={this.state.graphStartDateTime.unix()}
                      duration={this.state.duration}
                      prediction={newDispatch.prediction}
                      adjustedPrediction={newDispatch.adjustedPrediction}
                      marketPrediction={newDispatch.trading ? newDispatch.trading.market.rrp : null}
                      timezone={this.props.user.account.timezone}
                      handleStartDateTimeChange={this.handleStartDateTimeChange}
                      handleDurationChange={this.handleDurationChange}
                      showMarketData={
                        this.props.user.account.suborg_type === "RETAILER" ||
                        hasPermission(
                          this.props.user.permissions,
                          Permissions.fleet.dispatches.marketTrader
                        )
                      }
                    />
                  </div>
                ) : (
                  <div style={{ position: "relative", height: "8em" }}>
                    <Loading />
                  </div>
                )
              ) : null}
            </div>
          </div>
        </Modal.Content>
        <Modal.Footer>{this.renderFooter(isLoading)}</Modal.Footer>
      </Modal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RescheduleRertDispatchModal);
